import React from 'react'
import { Outlet } from 'react-router-dom'
import "./extrac.css"

const ExtractDataPage = () => {
  return (
    <section className='extract-section'>
        <Outlet />
    </section>
  )
}

export default ExtractDataPage
